import React from 'react';
import { t } from '../../helpers/translate';

class FileInputComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileCount: 0
    };
  }

  handleFileSelection(e) {
    const files = e.target.files;
    this.setState({ fileCount: files.length });

    if (this.props.onUpload) {
      this.props.onUpload(e);
    }
  }

  render() {
    const { fileCount } = this.state;
    return (
      <div className="file-upload-wrapper">
        <label htmlFor="file-upload" className="custom-file-upload">
          {t('Choose files')}
        </label>
        <input
          id="file-upload"
          type="file"
          accept={this.props.accept || ''}
          multiple
          onChange={this.handleFileSelection.bind(this)}
          style={{ display: 'none' }}
          ref={this.props.inputRef}
        />
        <span className="file-status">
          {fileCount === 0 ? t('No file chosen') : `${fileCount} ${t('file')}${fileCount > 1 ? 's' : ''}`}
        </span>
      </div>
    );
  }
}

export default FileInputComponent;


// WEBPACK FOOTER //
// ./src/components/common/FileInputComponent.js